//重点客户管理
import _import from '@/utils/import'
const Layout = _import('layout/Layout')
let keyAccountManage = [
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'carUnpetrifiedComAll', //全部
        component: _import('keyAccountManage/carUnpetrifiedComAll/index'),
        name: 'carUnpetrifiedComAll',
        meta: {
          title: '全部客户列表',
          icon: 'widgets'
        }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'carUnpetrifiedComGoal', //目标
        component: _import('keyAccountManage/carUnpetrifiedComGoal/index'),
        name: 'carUnpetrifiedComGoal',
        meta: {
          title: '目标客户列表',
          icon: 'widgets'
        }
      }
    ]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'cardListUser', //联名卡在用客户列表
        component: _import('keyAccountManage/cardListUser/index'),
        name: 'cardListUser',
        meta: {
          title: '联名卡在用客户列表',
          icon: 'widgets'
        }
      }
    ]
  }
]
export default keyAccountManage
